module.exports = __webpack_public_path__ + "static/media/winroy.18ee5d2f.png";